export default {
  nav: {
    home: '首页',
    course: '球场',
    setmeal: '套餐',
    order: '订单',
    profile: '我的',
  },
  home: {
    domestic: '国内订场',
    overseas: '海外球场',
    setmeal: '精选套餐',
    travel: '高尔夫旅游',
    weather: '球场天气',
  },
  course: {
    domestic: '国内球场',
    overseas: '海外球场',
    search: '搜索球场',
    allDomestic: '全国球场',
    allOverseas: '全球球场',
    selectRegion: '选择地区',
    teeTime: '开球时间',
    bookNow: '立即预订',
    collected: '已收藏',
    collect: '收藏',
    noData: '暂无球场数据',
    featured: '精选',
    distance: '距离',
  },
  setmeal: {
    title: '精选套餐',
    detail: '套餐详情',
    from: '起',
    buyNow: '立即购买',
    noData: '暂无套餐',
    people: '人',
    days: '天',
  },
  booking: {
    confirm: '确认订单',
    players: '同行球友',
    self: '本人',
    addPlayer: '添加球友',
    coupon: '优惠券',
    noCoupon: '暂无可用优惠券',
    cost: '费用明细',
    reservePrice: '预订费',
    subsidy: '补贴',
    total: '合计',
    submit: '提交订单',
    offlinePay: '到场支付',
    onlinePay: '在线支付',
  },
  payment: {
    title: '支付',
    wechat: '微信支付',
    alipay: '支付宝',
    qrScan: '扫码支付',
    scanHint: '请使用微信/支付宝扫描二维码完成支付',
    waiting: '等待支付中...',
    success: '支付成功',
    fail: '支付失败',
    timeout: '支付超时，请重新发起',
    viewOrder: '查看订单',
    retry: '重新支付',
  },
  order: {
    title: '我的订单',
    all: '全部',
    pending: '待支付',
    confirmed: '已确认',
    completed: '已完成',
    cancelled: '已取消',
    noData: '暂无订单',
    payNow: '立即支付',
    cancel: '取消订单',
    refund: '申请退款',
    detail: '查看详情',
    invoice: '申请发票',
  },
  auth: {
    login: '登录',
    phone: '手机号',
    code: '验证码',
    sendCode: '获取验证码',
    resend: '重新获取',
    agree: '已阅读并同意',
    terms: '《用户协议》',
    privacy: '《隐私政策》',
    loginBtn: '登录',
    phonePlaceholder: '请输入手机号',
    codePlaceholder: '请输入验证码',
    loginSuccess: '登录成功',
  },
  user: {
    profile: '个人中心',
    myOrder: '我的订单',
    aboutUs: '关于我们',
    logout: '退出登录',
    logoutConfirm: '确定退出登录吗？',
    confirm: '确定',
    cancel: '取消',
  },
  common: {
    loading: '加载中...',
    noMore: '没有更多了',
    networkError: '网络错误，请重试',
    back: '返回',
    confirm: '确认',
    cancel: '取消',
    yuan: '元',
    free: '免费',
  },
}
